const initialState = {
    flag: false,
    modal: '',
    isTabletOrMobile: false,
};

const toggleModal = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_MODAL':
            return {
                ...state,
                flag: action.flag,
                modal: action.modal
            };
        case 'CHECK_IF_MOBILE_SIZE':
            return {
                ...state,
                isTabletOrMobile: action.isTabletOrMobile,
            };
        default:
            return state
    }
};

export default toggleModal
